import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card} from 'semantic-ui-react';
import Loader from '../../common/components/loader';
import InfoDetail from './infoDetail';
import GeneralServiceReportTable from './generalTable';

class ServiceReportPartInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'dealerName': '',
      'serviceFee': 0,
      'agencies': [],
    };
  }

  componentDidUpdate() {
    const {
      settingInfo,
      dealerId,
      setSettingInfo,
      isUserFromTDE,
      serviceRateList,
      serviceRateLoading,
    } = this.props;
  
    if (!isUserFromTDE && settingInfo && !serviceRateLoading) {
      const dealerInfo = serviceRateList.find((service) => {
        return service.dealerCode === dealerId;
      });
      this.setState({...dealerInfo, 'dealerCode': dealerId});
      setSettingInfo(false);
    }
  }

  setDealerDetail = (dealerName = '') => {
    if (dealerName) {
      const {serviceRateList} = this.props;
      const dealerInfo = serviceRateList.find((service) => service.dealerName === dealerName);
      this.setState({...dealerInfo, dealerName});
    } else {
      this.setState({'dealerName': ''});
    }
  };

  render() {
    const {dealerName, agencies, serviceFee, orders, ordersServed} = this.state;
    const {isUserFromTDE, serviceRateList, serviceRate, serviceRateLoading, settingInfo} =
      this.props;

    if (serviceRateLoading || (!isUserFromTDE && settingInfo)) {
      return (
        <Card raised fluid className='card-loader'>
          <Loader />
        </Card>
      );
    }

    if (isUserFromTDE) {
      return (
        <Card fluid className="service-rate-info">
          <Card raised fluid className={dealerName ? 'half' : 'full'}>
            <Card.Content>
              <Card.Description>
                <GeneralServiceReportTable
                  list={serviceRateList}
                  setDealerDetail={this.setDealerDetail}
                  totals={serviceRate}
                />
              </Card.Description>
            </Card.Content>
          </Card>
          {dealerName && (
            <InfoDetail
              dealer={dealerName}
              orders={orders}
              ordersServed={ordersServed}
              agencies={agencies}
              serviceFee={serviceFee}
              setDealerDetail={this.setDealerDetail}
            />
          )}
        </Card>
      );
    }

    return (
      <Card fluid className='service-rate-info'>
        <InfoDetail dealer={dealerName} serviceFee={serviceFee} agencies={agencies} />
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'serviceRateList': state.serviceRate.serviceRateDealers,
    'serviceRate': state.serviceRate.serviceRate,
    'serviceRateLoading': state.serviceRate.loading,
    'isUserFromTDE': state.session.isUserFromTDE,
    'dealerId': state.session.dealerId,
  };
};

export default connect(mapStateToProps, {})(ServiceReportPartInfo);
